export const siteEnum = {
  XF1: '1',
  IND: '5',
  DY2: '6',
  LH1: '7',
  VNM: '8',
  IW2: '9',
  KRW: '10',
  PAK: '11',
  BGD: '12',
  NGA: '14',
  KAKA: '15',
  PH1: '16',
  ID1: '17',
  BR1: '18',
  PK2: '19',
  PK3: '20',
  MX1: '21',
  CO1: '22',
  TH2: '23',
  PK4: '26',
  AU1: '27',
  BR2: '28',
  TH3: '29',
  LK6: '30',
  AK2: '31',
  PH2: '37',
  MX4: '48'
}
